<template>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   inkscape:version="1.1-dev (ddb55ca, 2020-02-02)"
   sodipodi:docname="print.svg"
   id="svg852"
   version="1.1"
   viewBox="0 0 25 26"
   height="26"
   width="25"
   class="pictoPrint">
  <metadata
     id="metadata856">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <sodipodi:namedview
     inkscape:current-layer="svg852"
     inkscape:window-maximized="0"
     inkscape:window-y="26"
     inkscape:window-x="0"
     inkscape:cy="20.586031"
     inkscape:cx="11.295571"
     inkscape:zoom="24.458333"
     showgrid="false"
     id="namedview854"
     inkscape:window-height="814"
     inkscape:window-width="1344"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0"
     guidetolerance="10"
     gridtolerance="10"
     objecttolerance="10"
     borderopacity="1"
     bordercolor="#666666"
     pagecolor="#ffffff" />
  <defs
     id="defs836">
  </defs>
  <g
     style="stroke-opacity:1"
     id="g850">
    <path
       inkscape:connector-curvature="0"
       style="stroke-opacity:1"
       id="path838"
       stroke-width="1"
       stroke-linejoin="round"
       stroke-linecap="round"
       fill="none"
       d="m 5.5,20.5 v -19 a 1,1 0 0 1 1,-1 h 15 a 1,1 0 0 1 1,1 v 19 a 3,3 0 0 1 -3,3 h -14" />
    <path
       inkscape:connector-curvature="0"
       style="stroke-opacity:1"
       id="path840"
       stroke-width="1"
       stroke-linejoin="round"
       stroke-linecap="round"
       fill="none"
       d="m 3,23.5 v 0 A 2.5,2.5 0 0 1 0.5,21 v -9.5 a 1,1 0 0 1 1,-1 h 4 V 21 A 2.5,2.5 0 0 1 3,23.5 Z" />
    <line
       y2="0"
       x2="0"
       y1="0"
       style="stroke-opacity:1"
       id="line842"
       stroke-width="1"
       stroke-linejoin="round"
       stroke-linecap="round"
       fill="none"
       transform="translate(3.5,23.5)"
       x1="5" />
    <line
       y2="0"
       y1="0"
       x1="0"
       style="stroke-opacity:1"
       id="line844"
       stroke-width="1"
       stroke-linejoin="round"
       stroke-linecap="round"
       fill="none"
       transform="translate(9.5,4.5)"
       x2="9" />
    <line
       y2="0"
       y1="0"
       x1="0"
       style="stroke-opacity:1"
       id="line846"
       stroke-width="1"
       stroke-linejoin="round"
       stroke-linecap="round"
       fill="none"
       transform="translate(9.5,8.5)"
       x2="9" />
    <line
       y2="0"
       y1="0"
       x1="0"
       style="stroke-opacity:1"
       id="line848"
       stroke-width="1"
       stroke-linejoin="round"
       stroke-linecap="round"
       fill="none"
       transform="translate(9.5,12.5)"
       x2="9" />
  </g>
</svg>
</template>

<script>

export default {
  name: 'PictoPrint'
}
</script>
